import { render, staticRenderFns } from "./Encounter_tpGoal.vue?vue&type=template&id=72edeec4&scoped=true&lang=html"
import script from "./Encounter_tpGoal.vue?vue&type=script&lang=js"
export * from "./Encounter_tpGoal.vue?vue&type=script&lang=js"
import style0 from "./Encounter_tpGoal.vue?vue&type=style&index=0&id=72edeec4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72edeec4",
  null
  
)

export default component.exports